import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { UserService } from './service/user.service';
import { ELocalStorage } from './enums/ELocalStorage';

@Component({
    selector: 'app-root',
    imports: [ RouterOutlet, Header, Footer, Toast ],
    templateUrl: './app.html',
    standalone: true,
    styleUrl: './app.scss'
})
export class App implements OnInit {
    isScrolled: boolean = false;
    hideTopStrip = false;

    constructor(private userService: UserService) {
    }

    async ngOnInit() {
        // const loader = document.getElementById('app-loader');
        // if (loader) {
        //     setTimeout(() => {
        //         loader.style.display = 'none';
        //     }, 500);
        // }

        let defaultAMToken: any = await this.userService.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);
    }
}
